module.exports = __webpack_public_path__ + "29c91b0f813338f2b26e2c7e9ea832e8.svg";